import React from 'react';
import { GameLogEntry } from '../api';

interface GameLogProps {
  log: GameLogEntry[];
}

export const GameLog: React.FC<GameLogProps> = ({ log }) => {
  if (!log || log.length === 0) {
    return null;
  }

  // Reverse the log to show newest entries first
  const reversedLog = [...log].reverse();

  return (
    <div className="game-log">
      <div className="log-entries">
        {reversedLog.map((entry, idx) => {
          const timestamp = new Date(entry.timestamp).toLocaleTimeString();
          return (
            <div key={idx} className="log-entry">
              <span className="log-timestamp">[{timestamp}]</span>
              <span className="log-message">{entry.message}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
